import { Fragment } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Typography } from '@components/Typography';
import { Select } from '@components/Select';
import { useTranslation } from '@hooks';

const StyledRadioGroup = styled(RadioGroup)({
    flexDirection: 'row',
    alignItems: 'center',
    '& .MuiFormControlLabel-root': {
        marginRight: 0,
        marginLeft: '-3px !important',
    },
});

export const HandoffMap = {
    Disabled: 0,
    Enabled: 1,
};

const Handoff = ({ isView, isMobile }) => {
    const { t } = useTranslation();
    const { control, setValue } = useFormContext();

    const responseTimeOptions = [
        { value: 0, label: t('common.disabled') },
        { value: 1, label: t('Agents.fewMinutes') },
        { value: 2, label: t('Agents.withinHour') },
        { value: 3, label: t('Agents.fewHours') },
        { value: 4, label: t('Agents.withinDay') },
        { value: 5, label: t('Agents.within2Days') },
    ];

    return (
        <div>
            <Typography variant="subtitle1" sx={{ color: 'var(--text-primary)' }}>
                {t('Agents.conversationHandoff')}
            </Typography>
            <Typography variant="caption" sx={{ color: 'var(--text-secondary)', display: 'block', marginTop: '4px' }}>
                {t('Agents.conversationHandoffDescription')}
            </Typography>
            <Controller
                control={control}
                name="handoff"
                render={({ field }) => (
                    <div style={{ gridColumn: !isMobile && '1 / span 2' }}>
                        {[
                            { id: `${HandoffMap.Enabled}`, name: t('Agents.conversationHandoffSwitch') },
                            { id: `${HandoffMap.Disabled}`, name: t('Agents.notTransferConversationSwitch') },
                        ].map(type => (
                            <Fragment key={type.id}>
                                <StyledRadioGroup
                                    value={field.value}
                                    onChange={e =>
                                        setValue('handoff', e.target.value, {
                                            shouldDirty: true,
                                            shouldValidate: true,
                                        })
                                    }
                                >
                                    <FormControlLabel
                                        value={`${type.id}`}
                                        control={
                                            <Radio
                                                sx={{
                                                    color: 'var(--text-secondary)',
                                                    padding: '6px',
                                                    '&.Mui-checked': { color: 'var(--primary-main)' },
                                                }}
                                                disabled={isView}
                                            />
                                        }
                                        label={
                                            <Typography variant="body2" sx={{ marginLeft: '10px' }}>
                                                {type.name}
                                            </Typography>
                                        }
                                        disabled={isView}
                                    ></FormControlLabel>
                                </StyledRadioGroup>
                                {field.value === `${HandoffMap.Enabled}` && type.id === `${HandoffMap.Enabled}` && (
                                    <Controller
                                        control={control}
                                        name="handoffResponseTime"
                                        render={({ field, fieldState: { error }, ref }) => (
                                            <Select
                                                {...field}
                                                ref={ref}
                                                onChange={({ target: { value } }) => {
                                                    setValue('handoffResponseTime', value, {
                                                        shouldDirty: true,
                                                        shouldValidate: true,
                                                    });
                                                }}
                                                options={responseTimeOptions}
                                                label={t('Agents.handoffResponseTime')}
                                                fullWidth
                                                required
                                                disabled={isView}
                                                error={!!error}
                                                helperText={error ? t(error.message) : null}
                                                style={{
                                                    width: isMobile ? '100%' : 'calc(50% - 12px)',
                                                    marginTop: '8px',
                                                }}
                                            />
                                        )}
                                    />
                                )}
                            </Fragment>
                        ))}
                    </div>
                )}
            />
        </div>
    );
};

export default Handoff;
